export default __webpack_public_path__ + "static/media/rewards3.cfd343e3.svg";